<template>
  <div v-if="pdfurl">
    <modal name="my-first-modal" height="auto" scrollable width="90%">
      <div id="pdfvuer" >
        <div class="closeButton">
          <button @click="hide()">X</button>
        </div>
        <pdf :src="pdfurl" v-for="i in numPages" :key="i" :id="i" :page="i" :scale.sync="scale"
          style="width:50%;margin:20px auto;" :annotation="true" :resize="true" @link-clicked="handle_pdf_link">
        </pdf>

      </div>
    </modal>
  </div>
</template>

<script>
import pdfvuer from 'pdfvuer'

export default {
  name: 'App',
  components: {
    // pdfView,
    pdf: pdfvuer
  },
  data() {
    return {
      page: 1,
      numPages: 0,
      pdfdata: undefined,
      errors: [],
      scale: 'page-width',
      isVisible: false
    }
  },
  props: {
    pdfurl: String
  },
  computed: {
    formattedZoom() {
      return Number.parseInt(this.scale * 100);
    },
  },
  mounted() {
    this.getPdf()
  },
  watch: {
    show: function (s) {
      if (s) {
        this.getPdf();
      }
    },
    page: function (p) {
      if (window.pageYOffset <= this.findPos(document.getElementById(p)) || (document.getElementById(p + 1) && window.pageYOffset >= this.findPos(document.getElementById(p + 1)))) {
        // window.scrollTo(0,this.findPos(document.getElementById(p)));
        document.getElementById(p).scrollIntoView();
      }
    }
  },
  methods: {
    handle_pdf_link: function (params) {
      // Scroll to the appropriate place on our page - the Y component of
      // params.destArray * (div height / ???), from the bottom of the page div
      var page = document.getElementById(String(params.pageNumber));
      page.scrollIntoView();
    },
    getPdf() {
      var self = this;
      self.pdfdata = pdfvuer.createLoadingTask(self.pdfurl);
      self.pdfdata.then(pdf => {
        self.numPages = pdf.numPages;
        window.onscroll = function () {
          changePage()
          //stickyNav()  
        }

        // // Get the offset position of the navbar
        // var sticky = $('#buttons')[0].offsetTop

        // // Add the sticky class to the self.$refs.nav when you reach its scroll position. Remove "sticky" when you leave the scroll position
        // function stickyNav() {
        //   if (window.pageYOffset >= sticky) {
        //     $('#buttons')[0].classList.remove("hidden")
        //   } else {
        //     $('#buttons')[0].classList.add("hidden")
        //   }
        // }

        function changePage() {
          var i = 1, count = Number(pdf.numPages);
          do {
            if (window.pageYOffset >= self.findPos(document.getElementById(i)) &&
              window.pageYOffset <= self.findPos(document.getElementById(i + 1))) {
              self.page = i
            }
            i++
          } while (i < count)
          if (window.pageYOffset >= self.findPos(document.getElementById(i))) {
            self.page = i
          }
        }
      });
    },
    findPos(obj) {
      return obj.offsetTop;
    },
    show() {
      this.$modal.show('my-first-modal');
    },
    hide() {
      this.$modal.hide('my-first-modal');
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.buttonDiv {
  margin-top: 20px;
  position: fixed;
  
}
.closeButton{
  text-align: end;
  margin: 10px;
}
.closeButton button{
  background-color: transparent;
  border: 1px solid rgb(236, 103, 103);
  border-radius: 5px;
  padding: 5px;
  cursor: pointer;
  transition: 0.4s;
}
.closeButton button:hover{
  background-color: rgb(236, 103, 103);
  color: white;
}
</style>
<style src="pdfvuer/dist/pdfvuer.css">
</style>
<style lang="css" scoped>
#buttons {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

/* Page content */
.content {
  padding: 16px;
}
</style>